import { Config } from "../../../assets/svg-icons";

export const INTEGRATION = {
  name: "Integration Hub",
  shortName: "Integration",
  route: "/admin/integration",
  permissions: ["BU_VIEW"],
  icon: Config,
  extraRoutes: [
    {
      route: "/admin/integration/pipelines",
      permissions: ["BU_VIEW"],
    },
    {
      route: "/admin/integration/pipelines/new",
      permissions: ["BU_VIEW"],
    },
    {
      route: "/admin/integration/pipelines/:id/edit",
      permissions: ["BU_VIEW"],
    },
    {
      route: "/admin/integration/pipelines/:id/executions",
      permissions: ["BU_VIEW"],
    },
    {
      route: "/admin/integration/components",
      permissions: ["BU_VIEW"],
    },
  ],
};
